export default __webpack_public_path__ + "static/media/Achiton of the Ascension.4249fe91.jpg";